<template>
  <div>
    <router-view />
    <update-handler />
    <authorization-error-dialog />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AuthorizationErrorDialog from "./components/AuthorizationErrorDialog";
import UpdateHandler from "./components/UpdateHandler";

export default {
  name: "App",
  components: {
    UpdateHandler,
    AuthorizationErrorDialog,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.resetLoading();
    this.hideSnackbar();
  },
  methods: {
    ...mapActions("loading", {
      resetLoading: "reset",
    }),
    ...mapActions("snackbar", {
      hideSnackbar: "hide",
    }),
  },
};
</script>

<style lang="scss">
.circle_chip {
  padding: 1px 4px 3px;
  border-radius: 15px;
  font-size: 80%;
  font-weight: 700;
  &.red {
    background-color: red;
    color: white;
  }
}

.stretchedChip {
  width: 100%;
  text-align: center;
  display: inline-block !important;
}

.stretchedChip .v-chip__content {
  vertical-align: super;
}

.v-select__selection {
  line-height: initial !important;
}

.required {
  color: red;

  &:after {
    content: "\3014\5FC5\9808\9805\76EE\3015";
  }
}
.requiredMark {
  .v-label:after {
    content: "\3014\5FC5\9808\9805\76EE\3015";
  }
}

.line-break {
  white-space: pre-line;
}

// https://mycolor.space/gradient
.primary-gradients {
  background: transparent linear-gradient(214deg, #1faad1 0%, #3673b4 100%) 0 0
    no-repeat padding-box;
  opacity: 1;
}

.error-gradients {
  background: transparent linear-gradient(211deg, #ea8f66 0%, #c66048 100%) 0 0
    no-repeat padding-box;
  color: white;
}

.v-data-table {
  white-space: pre-line;
}

.v-data-table thead th {
  font-size: 0.65rem !important;
}

.z-index_zero {
  z-index: 0 !important;
}
</style>
